import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Home from "./views/Home";

Vue.use(Router);

export default new Router({

  linkExactActiveClass: "active",
  routes: [
    {
      path: "*",
      name: "main",
      components: {
        // header: AppHeader,
        default: Home,
        footer: AppFooter
      }
    },
  ],
  // mode: 'history',
  scrollBehavior: to => {

    console.log('to',to);

    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const element = document.getElementById(to.hash.substring(1));
          console.log("element ",element);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
          resolve();
        }, 500); // 調整延遲時間以確保元素正確載入
      });
      // return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
